import apiRequest from './apiRequest';

export type PrepareRenderCanvasResponse = {
  message: string;
  poseID: string;
};

export type PostPrepareRenderCanvasPayload = {
  characterID: string;
  prompt: string;
  imageBase64: string;
};

export default async function postPrepareRenderCanvas(
  projectID: string,
  body: PostPrepareRenderCanvasPayload,
) {
  return await apiRequest<PrepareRenderCanvasResponse>(
    'mogen-orchestration',
    `/v2/projects/${projectID}/prepareRenderCanvas`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}
